import { AppDefaultNavigationState } from '../../../initialStateRegistration';

export const getHeader = (state: AppDefaultNavigationState) => state.header;

export const getSubHeader = (state: AppDefaultNavigationState) => getHeader(state).subHeader;
